import { useAppSelector } from '../../../../ReduxToolkit/Hooks';
import { H6 } from '../../../../AbstractElements';
import { Checkout, TotalPrice } from '../../../../utils/Constant';
import { Link } from 'react-router-dom';
import { getallCardTotal } from '../../../../Service/Ecommerce.service';
import { formatPrice } from '../../../../utils/helper/helpers';

const CartAction = () => {
  const { cart } = useAppSelector((state) => state.cartData);
  return (
    <>
      <tr>
        <td className="total-amount" colSpan={3}>
          <H6 className="m-0 text-end" >
            <span className="f-w-600">{TotalPrice} :</span>
          </H6>
        </td>
        <td colSpan={2}><span>{formatPrice(getallCardTotal(cart))}</span></td>
      </tr>
      <tr>
        <td colSpan={5} className='text-end'>
          <Link className="btn btn-primary cart-btn-transform" to={`${process.env.PUBLIC_URL}/checkout`}>Valider la vente</Link>
        </td>
      </tr>
    </>
  )
}

export default CartAction